module.exports = __webpack_public_path__ + "templates.facebook-messenger-checkbox-v2-cd25ead9.html";